import React from 'react';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';

interface Props {
  onExecute: () => void;
  /** Marker der Nutzungserfassung (RITA-1504); der Wrapper bildet ihn aus dem Tabellennamen. */
  usageKey?: string;
}

function CommitButton({ onExecute, usageKey }: Props) {
  return (
    <IconButton onClick={onExecute} title="Änderungen speichern" data-usage={usageKey}>
      <SaveIcon />
    </IconButton>
  );
}

export default CommitButton;
